import { render } from "./SensitiveDetails.vue?vue&type=template&id=2618d745"
import script from "./SensitiveDetails.vue?vue&type=script&lang=js"
export * from "./SensitiveDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__